/* eslint-disable */
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Spin,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [selectLoading, setSelectLoading] = useState(false);
  
  // 两个 Select 的数据
  const [z64Options, setZ64Options] = useState([]); // glChartNameId = 1
  const [genOptions, setGenOptions] = useState([]); // glChartNameId = 2

  // 获取 Select 数据
  const fetchSelectOptions = async () => {
    setSelectLoading(true);
    try {
      const [z64Res, genRes] = await Promise.all([
        http.get(api.getGlAcctSOListByNameId, { params: { glChartNameId: "1" } }),
        http.get(api.getGlAcctSOListByNameId, { params: { glChartNameId: "2" } }),
      ]);
      
      const z64List = (z64Res.data || []).map((item) => ({
        label: `${item.label?.glAcct || ''} - ${item.label?.title || ''}`,
        value: item.label?.glChartId,
      }));
      setZ64Options(z64List);
      
      const genList = (genRes.data || []).map((item) => ({
        label: `${item.label?.glAcct || ''} - ${item.label?.title || ''}`,
        value: item.label?.glChartId,
      }));
      setGenOptions(genList);
    } catch (error) {
      console.error("Failed to fetch select options:", error);
      message.error("Failed to load account options");
    } finally {
      setSelectLoading(false);
    }
  };

 useImperativeHandle(ref, () => ({
  setModelAdd: () => {
    setEditRecord(null);
    form.resetFields();
    form.setFieldsValue({
      name: "",
      code: "",
      z64GlAcctIds: [],
      genGlAcctIds: [],
    });
    setVisible(true);
    // 打开 modal 时获取数据
    fetchSelectOptions();
  },
  setModelEdit: (record) => {
    console.log(record);
    setEditRecord(record);
    
    // 提取 glChartId 数组
    const z64Ids = (record.z64GlAcctList || []).map(item => item.glChartId);
    const genIds = (record.genGlAcctList || []).map(item => item.glChartId);
    
    form.setFieldsValue({
      name: record.name,
      code: record.code,
      status: record.status,
      z64GlAcctIds: z64Ids,
      genGlAcctIds: genIds,
    });
    setVisible(true);
    // 打开 modal 时获取数据
    fetchSelectOptions();
  },
}));

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (editRecord) {
        // 编辑模式 - 需要传入 id
        response = await http.post(api.getApModuleGlAcctUpdate, {
          id: editRecord.id,
          status: values.status || 0,
          name: values.name,
          code: values.code,
          z64GlAcctIds: values.z64GlAcctIds || [],
          genGlAcctIds: values.genGlAcctIds || [],
        });
      } else {
        // 新增模式
        response = await http.post(api.getApModuleGlAcctAdd, {
          name: values.name,
          code: values.code,
          z64GlAcctIds: values.z64GlAcctIds || [],
          genGlAcctIds: values.genGlAcctIds || [],
        });
      }

      if (response?.code === "1") {
        message.success(
          editRecord ? "Updated Successfully" : "Added Successfully",
        );
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
        onSuccess && onSuccess();
      } else {
        message.error(
          response?.msg || (editRecord ? "Update failed" : "Add failed"),
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            {editRecord
              ? "EDIT GL ACCOUNT SUB TYPE"
              : "ADD GL ACCOUNT SUB TYPE"}
          </Typography.Title>
        </Flex>
      }
      width="40%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
      }}
  styles={{
    body: {
      minHeight: "300px"
    }
  }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setEditRecord(null);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Spin spinning={selectLoading}>
              <Form
                form={form}
                name="createGLAccountSubTypeForm"
                layout="horizontal"
                labelCol={{ style: { width: "150px" } }}
                wrapperCol={{ style: { flex: 1 } }}
                onFinish={onFinish}
              >
                <Flex justify="space-between" align="flex-start">
                  <div style={{ flex: 1 }}>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[{ required: true, message: "Please enter Name" }]}
                    >
                      <Input placeholder="Please enter Name" allowClear />
                    </Form.Item>

                    <Form.Item
                      name="code"
                      label="Code"
                      rules={[{ required: true, message: "Please enter Code" }]}
                    >
                      <Input placeholder="Please enter Code" allowClear />
                    </Form.Item>

                    <Form.Item
                      name="z64GlAcctIds"
                      label="Z64 GL Accounts"
                      rules={[
                        { required: true, message: "Please select Z64 GL Accounts" }
                      ]}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Please select Z64 GL Accounts"
                        options={z64Options}
                        allowClear
                        loading={selectLoading}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        notFoundContent={selectLoading ? 'Loading...' : 'No results found'}
                      />
                    </Form.Item>

                    <Form.Item
                      name="genGlAcctIds"
                      label="Gen GL Accounts"
                      rules={[
                        { required: true, message: "Please select Gen GL Accounts" }
                      ]}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Please select Gen GL Accounts"
                        options={genOptions}
                        allowClear
                        loading={selectLoading}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        notFoundContent={selectLoading ? 'Loading...' : 'No results found'}
                      />
                    </Form.Item>

                    {editRecord && (
                      <Form.Item
                        name="status"
                        label="Status"
                        rules={[
                          { required: true, message: "Please select Status" },
                        ]}
                      >
                        <Select
                          placeholder="Select Status"
                          options={[
                            { label: "Active", value: 1 },
                            { label: "Inactive", value: 0 },
                          ]}
                          allowClear
                        />
                      </Form.Item>
                    )}
                  </div>
                </Flex>
              </Form>
            </Spin>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;